import { useMemo } from 'react';
import {
  useQuery,
  QueryObserverResult,
  RefetchOptions,
} from '@tanstack/react-query';
import {
  AlertCamera,
  CameraTimeLapseFrameDetails,
} from 'features/cameras/cameras.types';
import { fetchCameraTimeLapse } from 'features/cameras/hooks/useAlertCameraPlayerState/useAlertCameraPlayerState.utils';

export type UseAlertCameraTimelapseFramesReturn = {
  isFetchingTimelapseFrames: boolean;
  timelapseFrames: CameraTimeLapseFrameDetails[];
  refetchTimelapseFrames: (
    options?: RefetchOptions | undefined,
  ) => Promise<QueryObserverResult<CameraTimeLapseFrameDetails[], Error>>;
};

export const useAlertCameraTimelapseFrames = (
  replayTime: number,
  camera?: AlertCamera,
  enabled = false,
): UseAlertCameraTimelapseFramesReturn => {
  const { isFetching, data, refetch } = useQuery({
    queryKey: ['camera-timelapse', camera?.id, replayTime],
    queryFn: () => fetchCameraTimeLapse(camera!.id, replayTime.toString()),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: Boolean(camera?.id) && enabled,
  });

  const timelapseFrames = useMemo(() => data || [], [data]);
  return {
    isFetchingTimelapseFrames: isFetching,
    timelapseFrames,
    refetchTimelapseFrames: refetch,
  };
};
